module.exports = __webpack_public_path__ + "static/media/extraDelivery.bf3935dc.svg";